'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var styled = _interopDefault(require('styled-components'));
var propTypes = require('prop-types');

/* Basic theme with minimal styling. Nearly unstyled.*/
var DefaultTheme = {
  fontFamily: 'Futura PT,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Arial,sans-serif',
  fontWeight: 400,
  headingFontWeight: 600,
  primaryColor: 'rgba(0,0,0,.6)',
  secondaryColor: '#f8f8f9',
  codeFont: 'Space Mono,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace',
  fontColor: 'rgb(46, 68, 78)',
  fontSize: '16px',
  red: '#DB2828',
  orange: '#F2711C',
  yellow: '#FBBD08',
  olive: '#B5CC18',
  green: '#21BA45',
  teal: '#00B5AD',
  blue: '#2185D0',
  violet: '#6435C9',
  purple: '#A333C8',
  pink: '#E03997',
  brown: '#A5673F',
  grey: '#767676',
  black: '#1B1C1D'
};

/* Theme based on the `styed-components` website.*/
var Theme = {
  primaryColor: "#CE7692",
  secondaryColor: "#FDEFD8",
  fontSize: "16px"
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n  display: inline-block;\n  font-family: ', ';\n  padding-left: 1rem;\n  padding-right: 1rem;\n  position: relative;\n  vertical-align: top;\n  width: ', ';\n'], ['\n  display: inline-block;\n  font-family: ', ';\n  padding-left: 1rem;\n  padding-right: 1rem;\n  position: relative;\n  vertical-align: top;\n  width: ', ';\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  padding: 0em;\n\n  // Calculate width for contained columns.\n  ', ' {\n    width: ', ';\n  }\n'], ['\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  padding: 0em;\n\n  // Calculate width for contained columns.\n  ', ' {\n    width: ', ';\n  }\n']);

/**
 * A Column of the Grid.
 */
var Column = styled.div(_templateObject, function (props) {
  return props.theme.fontFamily;
}, function (_ref) {
  var width = _ref.width;
  return width;
});

/**
 * Container component for the Grid.
 */
var Grid = styled.div(_templateObject2, Column, function (_ref2) {
  var columns = _ref2.columns;
  return columns ? 100 / columns + '%' : '6.25%';
});
Column.defaultProps = { theme: DefaultTheme };

Grid.Column = Column;

var _templateObject$1 = taggedTemplateLiteral(['\n  align-items: center;\n  border-right: 1px solid rgba(34, 36, 38, 0.22);\n  color: ', ';\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: ', ';\n  font-weight: normal;\n  line-height: 1;\n  padding: 0.9375em 1.125em;\n  position: relative;\n  text-decoration: none;\n  vertical-align: middle;\n  -webkit-box-flex: 0;\n  -webkit-box-align: center;\n  -ms-flex: 0 0 auto;\n  -ms-flex-align: center;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    color: rgba(0, 0, 0, 0.95);\n  }\n  &:active {\n    color: ', ';\n  }\n'], ['\n  align-items: center;\n  border-right: 1px solid rgba(34, 36, 38, 0.22);\n  color: ', ';\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: ', ';\n  font-weight: normal;\n  line-height: 1;\n  padding: 0.9375em 1.125em;\n  position: relative;\n  text-decoration: none;\n  vertical-align: middle;\n  -webkit-box-flex: 0;\n  -webkit-box-align: center;\n  -ms-flex: 0 0 auto;\n  -ms-flex-align: center;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    color: rgba(0, 0, 0, 0.95);\n  }\n  &:active {\n    color: ', ';\n  }\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n  display: flex;\n  border: ', ' solid\n    ', ';\n  border-radius: ', ';\n  margin: 1rem 0;\n  min-height: 2.875em;\n  //-webkit-box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.22) inset,\n  //  0px 0px 0px 0px rgba(0, 0, 0, 0);\n  //box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.22) inset,\n  //  0px 0px 0px 0px rgba(0, 0, 0, 0);\n  ', ' {\n    color: ', ';\n    border-width: ', ';\n  }\n\n  &:first-child {\n    margin-top: 0rem;\n  }\n  &:last-child {\n    margin-bottom: 0rem;\n  }\n'], ['\n  display: flex;\n  border: ', ' solid\n    ', ';\n  border-radius: ', ';\n  margin: 1rem 0;\n  min-height: 2.875em;\n  //-webkit-box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.22) inset,\n  //  0px 0px 0px 0px rgba(0, 0, 0, 0);\n  //box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.22) inset,\n  //  0px 0px 0px 0px rgba(0, 0, 0, 0);\n  ', ' {\n    color: ', ';\n    border-width: ', ';\n  }\n\n  &:first-child {\n    margin-top: 0rem;\n  }\n  &:last-child {\n    margin-bottom: 0rem;\n  }\n']);

var Item = styled.a(_templateObject$1, function (_ref) {
  var theme = _ref.theme;
  return theme.black;
}, function (props) {
  return props.theme.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.black;
});

var Menu = styled.div(_templateObject2$1, function (props) {
  return props.borderless ? 0 : '1px';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.grey;
}, function (_ref4) {
  var rounded = _ref4.rounded;
  return rounded ? '0.25rem' : 0;
}, Item, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.borderless ? 0 : '1px';
});

// Props
Menu.propTypes = {
  rounded: propTypes.PropTypes.bool
};

Menu.defaultProps = { theme: DefaultTheme };
Item.defaultProps = { theme: DefaultTheme };

Menu.Item = Item;

var _templateObject$2 = taggedTemplateLiteral(['\n  background: ', ';\n  border-radius: ', ';\n  color: ', ';\n  font-family: ', ';\n  line-height: 1.4285em;\n  min-height: 1em;\n  margin: 1em 0em;\n  padding: 1em 1.5em;\n  position: relative;\n  //color: rgba(0, 0, 0, 0.87);\n  -webkit-transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease,\n    -webkit-box-shadow 0.1s ease;\n  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease,\n    -webkit-box-shadow 0.1s ease;\n  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease,\n    box-shadow 0.1s ease;\n  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease,\n    box-shadow 0.1s ease, -webkit-box-shadow 0.1s ease;\n  -webkit-box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.22) inset,\n    0px 0px 0px 0px\n      ', ';\n  box-shadow: 0px 0px 0px 1px\n      ', ' inset,\n    0px 0px 0px 0px\n      ', ';\n  &:first-child {\n    margin-top: 0em;\n  }\n  &:last-child {\n    margin-bottom: 0em;\n  }\n'], ['\n  background: ', ';\n  border-radius: ', ';\n  color: ', ';\n  font-family: ', ';\n  line-height: 1.4285em;\n  min-height: 1em;\n  margin: 1em 0em;\n  padding: 1em 1.5em;\n  position: relative;\n  //color: rgba(0, 0, 0, 0.87);\n  -webkit-transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease,\n    -webkit-box-shadow 0.1s ease;\n  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease,\n    -webkit-box-shadow 0.1s ease;\n  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease,\n    box-shadow 0.1s ease;\n  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease,\n    box-shadow 0.1s ease, -webkit-box-shadow 0.1s ease;\n  -webkit-box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.22) inset,\n    0px 0px 0px 0px\n      ', ';\n  box-shadow: 0px 0px 0px 1px\n      ', ' inset,\n    0px 0px 0px 0px\n      ', ';\n  &:first-child {\n    margin-top: 0em;\n  }\n  &:last-child {\n    margin-bottom: 0em;\n  }\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n  display: block;\n  font-family: \'Lato\', \'Helvetica Neue\', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  margin: -0.14285714em 0em 0rem 0em;\n'], ['\n  display: block;\n  font-family: \'Lato\', \'Helvetica Neue\', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  margin: -0.14285714em 0em 0rem 0em;\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  opacity: 0.85;\n  margin: 0.75em 0em;\n  &:first-child {\n    margin-top: 0em;\n  }\n  &:last-child {\n    margin-bottom: 0em;\n  }\n'], ['\n  opacity: 0.85;\n  margin: 0.75em 0em;\n  &:first-child {\n    margin-top: 0em;\n  }\n  &:last-child {\n    margin-bottom: 0em;\n  }\n']);

/**
 * The Message container.
 */
var Message = styled.div(_templateObject$2, function (_ref) {
  var theme = _ref.theme;
  return theme.secondaryColor;
}, function (_ref2) {
  var rounded = _ref2.rounded;
  return rounded ? '0.25rem' : 0;
}, function (_ref3) {
  var theme = _ref3.theme,
      color = _ref3.color;
  return color ? theme[color] : theme.primaryColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (_ref4) {
  var theme = _ref4.theme,
      color = _ref4.color;
  return color ? theme[color] : theme.primaryColor;
}, function (_ref5) {
  var theme = _ref5.theme,
      color = _ref5.color;
  return color ? theme[color] : theme.primaryColor;
}, function (_ref6) {
  var theme = _ref6.theme,
      color = _ref6.color;
  return color ? theme[color] : theme.primaryColor;
});

var Header = styled.div(_templateObject2$2);

var Text = styled.p(_templateObject3);

// Props
Message.propTypes = {
  color: propTypes.PropTypes.string,
  rounded: propTypes.PropTypes.bool

  // Default Theme
};Message.defaultProps = { theme: DefaultTheme

  // Assign children
};Message.Header = Header;
Message.Text = Text;

var _templateObject$3 = taggedTemplateLiteral(['\n  background-color: ', ';\n  border: none;\n  border-radius: 0.125em;\n  color: ', ';\n  display: inline-block;\n  font-family: ', ';\n  font-size: 1em;\n  font-style: normal;\n  font-weight: bold;\n  line-height: 1em;\n  margin: 0em 0.125em;\n  min-height: 1em;\n  padding: 0.5833em 0.833em;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: baseline;\n'], ['\n  background-color: ', ';\n  border: none;\n  border-radius: 0.125em;\n  color: ', ';\n  display: inline-block;\n  font-family: ', ';\n  font-size: 1em;\n  font-style: normal;\n  font-weight: bold;\n  line-height: 1em;\n  margin: 0em 0.125em;\n  min-height: 1em;\n  padding: 0.5833em 0.833em;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: baseline;\n']);

/**
 * A Basic Label representing a HTML form label.
 */
var Badge = styled.span(_templateObject$3, function (_ref) {
  var theme = _ref.theme;
  return theme.secondaryColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.primaryColor;
}, function (props) {
  return props.theme.fontFamily;
});

// Default Theme
Badge.defaultProps = { theme: DefaultTheme };

var _templateObject$4 = taggedTemplateLiteral(['\n  display: block;\n  font-family: ', ';\n  margin: 0 auto;\n  max-width: 960px;\n\n  /* Mobile */\n  @media only screen and (max-width: 767px) {\n    width: auto;\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  /* Tablet */\n  @media only screen and (min-width: 768px) and (max-width: 991px) {\n    width: 723px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n\n  /* Small Monitor */\n  @media only screen and (min-width: 992px) and (max-width: 1199px) {\n    width: 933px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n\n  /* Large Monitor */\n  @media only screen and (min-width: 1200px) {\n    width: 1127px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n'], ['\n  display: block;\n  font-family: ', ';\n  margin: 0 auto;\n  max-width: 960px;\n\n  /* Mobile */\n  @media only screen and (max-width: 767px) {\n    width: auto;\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  /* Tablet */\n  @media only screen and (min-width: 768px) and (max-width: 991px) {\n    width: 723px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n\n  /* Small Monitor */\n  @media only screen and (min-width: 992px) and (max-width: 1199px) {\n    width: 933px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n\n  /* Large Monitor */\n  @media only screen and (min-width: 1200px) {\n    width: 1127px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n']);

/**
 * A Container limits it's content to a maximum width.
 */
var Container = styled.div(_templateObject$4, function (props) {
  return props.theme.fontFamily;
});

Container.defaultProps = {
  theme: DefaultTheme
};

var _templateObject$5 = taggedTemplateLiteral(['\n  border: none;\n  color: ', ';\n  font-family: ', ';\n  font-weight: bold;\n  line-height: 1.28571429em;\n  margin: calc(2rem - 0.14285714em) 0em 1rem;\n  padding: 0em 0em;\n  text-transform: none;\n'], ['\n  border: none;\n  color: ', ';\n  font-family: ', ';\n  font-weight: bold;\n  line-height: 1.28571429em;\n  margin: calc(2rem - 0.14285714em) 0em 1rem;\n  padding: 0em 0em;\n  text-transform: none;\n']);

/**
 * A major title block.
 */
var Header$1 = styled.div(_templateObject$5, function (props) {
  return props.color ? props.color : 'rgba(0, 0, 0, 0.87)';
}, function (props) {
  return props.theme.fontFamily;
});

Header$1.defaultProps = { theme: DefaultTheme };

var _templateObject$6 = taggedTemplateLiteral(['\n  display: block;\n  left: 50%;\n  margin: 0px;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  z-index: 1000;\n  /* \'transform\' (%) doesn\'t seem to work with \'animation\'. \n  Fixing it for now with an absolute value.\n  TODO: Solve with relative value (%).*/\n  -webkit-transform: translateY(-1.1rem);\n  transform: translateY(-1.1rem);\n\n  /* Static Shape */\n  &:before {\n    border-radius: 500rem;\n    border: 0.2em solid rgba(0, 0, 0, 0.1);\n    content: \'\';\n    height: 100%;\n    left: 50%;\n    position: absolute;\n    top: 0%;\n    width: 100%;\n  }\n\n  /* Active Shape */\n  &:after {\n    content: \'\';\n    height: 100%;\n    left: 50%;\n    border-radius: 500rem;\n    border-color: #767676 transparent transparent;\n    border-style: solid;\n    border-width: 0.2em;\n    box-shadow: 0px 0px 0px 1px transparent;\n    position: absolute;\n    top: 0%;\n    width: 100%;\n    animation: loader 0.6s linear;\n    animation-iteration-count: infinite;\n    -webkit-animation: loader 0.6s linear;\n    -webkit-animation-iteration-count: infinite;\n  }\n\n  /* Active Animation */\n  @-webkit-keyframes loader {\n    from {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes loader {\n    from {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n\n  &:before,\n  &:after {\n    height: 2.2rem;\n    margin: 0em 0em 0em -1.14rem;\n    width: 2.2rem;\n  }\n\n  /*!* Sizes *!\n.ui.mini.loader:before,\n.ui.mini.loader:after {\n  width: 1rem;\n  height: 1rem;\n  margin: 0em 0em 0em -0.5rem;\n}\n.ui.tiny.loader:before,\n.ui.tiny.loader:after {\n  width: 1.14285714rem;\n  height: 1.14285714rem;\n  margin: 0em 0em 0em -0.57142857rem;\n}\n.ui.small.loader:before,\n.ui.small.loader:after {\n  width: 1.71428571rem;\n  height: 1.71428571rem;\n  margin: 0em 0em 0em -0.85714286rem;\n}\n.ui.loader:before,\n.ui.loader:after {\n  width: 2.28571429rem;\n  height: 2.28571429rem;\n  margin: 0em 0em 0em -1.14285714rem;\n}\n.ui.large.loader:before,\n.ui.large.loader:after {\n  width: 3.42857143rem;\n  height: 3.42857143rem;\n  margin: 0em 0em 0em -1.71428571rem;\n}\n.ui.big.loader:before,\n.ui.big.loader:after {\n  width: 3.71428571rem;\n  height: 3.71428571rem;\n  margin: 0em 0em 0em -1.85714286rem;\n}\n.ui.huge.loader:before,\n.ui.huge.loader:after {\n  width: 4.14285714rem;\n  height: 4.14285714rem;\n  margin: 0em 0em 0em -2.07142857rem;\n}\n.ui.massive.loader:before,\n.ui.massive.loader:after {\n  width: 4.57142857rem;\n  height: 4.57142857rem;\n  margin: 0em 0em 0em -2.28571429rem;\n}\n\n!*-------------------\n      Coupling\n--------------------*!\n\n\n!* Show inside active dimmer *!\n.ui.dimmer .loader {\n  display: block;\n}\n\n!* Black Dimmer *!\n.ui.dimmer .ui.loader {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.dimmer .ui.loader:before {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n.ui.dimmer .ui.loader:after {\n  border-color: #FFFFFF transparent transparent;\n}\n\n!* White Dimmer (Inverted) *!\n.ui.inverted.dimmer .ui.loader {\n  color: rgba(0, 0, 0, 0.87);\n}\n.ui.inverted.dimmer .ui.loader:before {\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.ui.inverted.dimmer .ui.loader:after {\n  border-color: #767676 transparent transparent;\n}\n\n\n!*******************************\n             Types\n*******************************!\n\n\n!*-------------------\n        Text\n--------------------*!\n\n.ui.text.loader {\n  width: auto !important;\n  height: auto !important;\n  text-align: center;\n  font-style: normal;\n}\n\n\n!*******************************\n            States\n*******************************!\n\n.ui.indeterminate.loader:after {\n  -webkit-animation-direction: reverse;\n          animation-direction: reverse;\n  -webkit-animation-duration: 1.2s;\n          animation-duration: 1.2s;\n}\n.ui.loader.active,\n.ui.loader.visible {\n  display: block;\n}\n.ui.loader.disabled,\n.ui.loader.hidden {\n  display: none;\n}\n\n\n!*******************************\n            Variations\n*******************************!\n\n\n!*-------------------\n        Sizes\n--------------------*!\n\n\n!* Loader *!\n.ui.inverted.dimmer .ui.mini.loader,\n.ui.mini.loader {\n  width: 1rem;\n  height: 1rem;\n  font-size: 0.78571429em;\n}\n.ui.inverted.dimmer .ui.tiny.loader,\n.ui.tiny.loader {\n  width: 1.14285714rem;\n  height: 1.14285714rem;\n  font-size: 0.85714286em;\n}\n.ui.inverted.dimmer .ui.small.loader,\n.ui.small.loader {\n  width: 1.71428571rem;\n  height: 1.71428571rem;\n  font-size: 0.92857143em;\n}\n.ui.inverted.dimmer .ui.loader,\n.ui.loader {\n  width: 2.28571429rem;\n  height: 2.28571429rem;\n  font-size: 1em;\n}\n.ui.inverted.dimmer .ui.large.loader,\n.ui.large.loader {\n  width: 3.42857143rem;\n  height: 3.42857143rem;\n  font-size: 1.14285714em;\n}\n.ui.inverted.dimmer .ui.big.loader,\n.ui.big.loader {\n  width: 3.71428571rem;\n  height: 3.71428571rem;\n  font-size: 1.28571429em;\n}\n.ui.inverted.dimmer .ui.huge.loader,\n.ui.huge.loader {\n  width: 4.14285714rem;\n  height: 4.14285714rem;\n  font-size: 1.42857143em;\n}\n.ui.inverted.dimmer .ui.massive.loader,\n.ui.massive.loader {\n  width: 4.57142857rem;\n  height: 4.57142857rem;\n  font-size: 1.71428571em;\n}\n\n!* Text Loader *!\n.ui.mini.text.loader {\n  min-width: 1rem;\n  padding-top: 1.78571429rem;\n}\n.ui.tiny.text.loader {\n  min-width: 1.14285714rem;\n  padding-top: 1.92857143rem;\n}\n.ui.small.text.loader {\n  min-width: 1.71428571rem;\n  padding-top: 2.5rem;\n}\n.ui.text.loader {\n  min-width: 2.28571429rem;\n  padding-top: 3.07142857rem;\n}\n.ui.large.text.loader {\n  min-width: 3.42857143rem;\n  padding-top: 4.21428571rem;\n}\n.ui.big.text.loader {\n  min-width: 3.71428571rem;\n  padding-top: 4.5rem;\n}\n.ui.huge.text.loader {\n  min-width: 4.14285714rem;\n  padding*/\n'], ['\n  display: block;\n  left: 50%;\n  margin: 0px;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  z-index: 1000;\n  /* \'transform\' (%) doesn\'t seem to work with \'animation\'. \n  Fixing it for now with an absolute value.\n  TODO: Solve with relative value (%).*/\n  -webkit-transform: translateY(-1.1rem);\n  transform: translateY(-1.1rem);\n\n  /* Static Shape */\n  &:before {\n    border-radius: 500rem;\n    border: 0.2em solid rgba(0, 0, 0, 0.1);\n    content: \'\';\n    height: 100%;\n    left: 50%;\n    position: absolute;\n    top: 0%;\n    width: 100%;\n  }\n\n  /* Active Shape */\n  &:after {\n    content: \'\';\n    height: 100%;\n    left: 50%;\n    border-radius: 500rem;\n    border-color: #767676 transparent transparent;\n    border-style: solid;\n    border-width: 0.2em;\n    box-shadow: 0px 0px 0px 1px transparent;\n    position: absolute;\n    top: 0%;\n    width: 100%;\n    animation: loader 0.6s linear;\n    animation-iteration-count: infinite;\n    -webkit-animation: loader 0.6s linear;\n    -webkit-animation-iteration-count: infinite;\n  }\n\n  /* Active Animation */\n  @-webkit-keyframes loader {\n    from {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes loader {\n    from {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n\n  &:before,\n  &:after {\n    height: 2.2rem;\n    margin: 0em 0em 0em -1.14rem;\n    width: 2.2rem;\n  }\n\n  /*!* Sizes *!\n.ui.mini.loader:before,\n.ui.mini.loader:after {\n  width: 1rem;\n  height: 1rem;\n  margin: 0em 0em 0em -0.5rem;\n}\n.ui.tiny.loader:before,\n.ui.tiny.loader:after {\n  width: 1.14285714rem;\n  height: 1.14285714rem;\n  margin: 0em 0em 0em -0.57142857rem;\n}\n.ui.small.loader:before,\n.ui.small.loader:after {\n  width: 1.71428571rem;\n  height: 1.71428571rem;\n  margin: 0em 0em 0em -0.85714286rem;\n}\n.ui.loader:before,\n.ui.loader:after {\n  width: 2.28571429rem;\n  height: 2.28571429rem;\n  margin: 0em 0em 0em -1.14285714rem;\n}\n.ui.large.loader:before,\n.ui.large.loader:after {\n  width: 3.42857143rem;\n  height: 3.42857143rem;\n  margin: 0em 0em 0em -1.71428571rem;\n}\n.ui.big.loader:before,\n.ui.big.loader:after {\n  width: 3.71428571rem;\n  height: 3.71428571rem;\n  margin: 0em 0em 0em -1.85714286rem;\n}\n.ui.huge.loader:before,\n.ui.huge.loader:after {\n  width: 4.14285714rem;\n  height: 4.14285714rem;\n  margin: 0em 0em 0em -2.07142857rem;\n}\n.ui.massive.loader:before,\n.ui.massive.loader:after {\n  width: 4.57142857rem;\n  height: 4.57142857rem;\n  margin: 0em 0em 0em -2.28571429rem;\n}\n\n!*-------------------\n      Coupling\n--------------------*!\n\n\n!* Show inside active dimmer *!\n.ui.dimmer .loader {\n  display: block;\n}\n\n!* Black Dimmer *!\n.ui.dimmer .ui.loader {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.dimmer .ui.loader:before {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n.ui.dimmer .ui.loader:after {\n  border-color: #FFFFFF transparent transparent;\n}\n\n!* White Dimmer (Inverted) *!\n.ui.inverted.dimmer .ui.loader {\n  color: rgba(0, 0, 0, 0.87);\n}\n.ui.inverted.dimmer .ui.loader:before {\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.ui.inverted.dimmer .ui.loader:after {\n  border-color: #767676 transparent transparent;\n}\n\n\n!*******************************\n             Types\n*******************************!\n\n\n!*-------------------\n        Text\n--------------------*!\n\n.ui.text.loader {\n  width: auto !important;\n  height: auto !important;\n  text-align: center;\n  font-style: normal;\n}\n\n\n!*******************************\n            States\n*******************************!\n\n.ui.indeterminate.loader:after {\n  -webkit-animation-direction: reverse;\n          animation-direction: reverse;\n  -webkit-animation-duration: 1.2s;\n          animation-duration: 1.2s;\n}\n.ui.loader.active,\n.ui.loader.visible {\n  display: block;\n}\n.ui.loader.disabled,\n.ui.loader.hidden {\n  display: none;\n}\n\n\n!*******************************\n            Variations\n*******************************!\n\n\n!*-------------------\n        Sizes\n--------------------*!\n\n\n!* Loader *!\n.ui.inverted.dimmer .ui.mini.loader,\n.ui.mini.loader {\n  width: 1rem;\n  height: 1rem;\n  font-size: 0.78571429em;\n}\n.ui.inverted.dimmer .ui.tiny.loader,\n.ui.tiny.loader {\n  width: 1.14285714rem;\n  height: 1.14285714rem;\n  font-size: 0.85714286em;\n}\n.ui.inverted.dimmer .ui.small.loader,\n.ui.small.loader {\n  width: 1.71428571rem;\n  height: 1.71428571rem;\n  font-size: 0.92857143em;\n}\n.ui.inverted.dimmer .ui.loader,\n.ui.loader {\n  width: 2.28571429rem;\n  height: 2.28571429rem;\n  font-size: 1em;\n}\n.ui.inverted.dimmer .ui.large.loader,\n.ui.large.loader {\n  width: 3.42857143rem;\n  height: 3.42857143rem;\n  font-size: 1.14285714em;\n}\n.ui.inverted.dimmer .ui.big.loader,\n.ui.big.loader {\n  width: 3.71428571rem;\n  height: 3.71428571rem;\n  font-size: 1.28571429em;\n}\n.ui.inverted.dimmer .ui.huge.loader,\n.ui.huge.loader {\n  width: 4.14285714rem;\n  height: 4.14285714rem;\n  font-size: 1.42857143em;\n}\n.ui.inverted.dimmer .ui.massive.loader,\n.ui.massive.loader {\n  width: 4.57142857rem;\n  height: 4.57142857rem;\n  font-size: 1.71428571em;\n}\n\n!* Text Loader *!\n.ui.mini.text.loader {\n  min-width: 1rem;\n  padding-top: 1.78571429rem;\n}\n.ui.tiny.text.loader {\n  min-width: 1.14285714rem;\n  padding-top: 1.92857143rem;\n}\n.ui.small.text.loader {\n  min-width: 1.71428571rem;\n  padding-top: 2.5rem;\n}\n.ui.text.loader {\n  min-width: 2.28571429rem;\n  padding-top: 3.07142857rem;\n}\n.ui.large.text.loader {\n  min-width: 3.42857143rem;\n  padding-top: 4.21428571rem;\n}\n.ui.big.text.loader {\n  min-width: 3.71428571rem;\n  padding-top: 4.5rem;\n}\n.ui.huge.text.loader {\n  min-width: 4.14285714rem;\n  padding*/\n']);

var Loader = styled.div(_templateObject$6);

var _templateObject$7 = taggedTemplateLiteral(['\n  border-bottom: 1px solid rgba(34, 36, 38, 0.15);\n  font-family: ', ';\n  line-height: 2.875em;\n  min-height: 2.875em;\n  padding: 0.5rem 1rem;\n  position: relative;\n'], ['\n  border-bottom: 1px solid rgba(34, 36, 38, 0.15);\n  font-family: ', ';\n  line-height: 2.875em;\n  min-height: 2.875em;\n  padding: 0.5rem 1rem;\n  position: relative;\n']);

var NavBar = styled.div(_templateObject$7, function (props) {
  return props.theme.fontFamily;
});
NavBar.defaultProps = { theme: DefaultTheme };

var _templateObject$8 = taggedTemplateLiteral(['\n  background: #ffffff;\n  border-radius: ', ';\n  border: 1px solid rgba(34, 36, 38, 0.15);\n  box-shadow: 0px 1px 2px 0 rgba(34, 36, 38, 0.15);\n  font-family: ', ';\n  margin: 1rem 0em;\n  padding: 1em 1em;\n  position: relative;\n  -webkit-box-shadow: 0px 1px 2px 0 rgba(34, 36, 38, 0.15);\n'], ['\n  background: #ffffff;\n  border-radius: ', ';\n  border: 1px solid rgba(34, 36, 38, 0.15);\n  box-shadow: 0px 1px 2px 0 rgba(34, 36, 38, 0.15);\n  font-family: ', ';\n  margin: 1rem 0em;\n  padding: 1em 1em;\n  position: relative;\n  -webkit-box-shadow: 0px 1px 2px 0 rgba(34, 36, 38, 0.15);\n']);

var Segment = styled.div(_templateObject$8, function (props) {
  return props.rounded ? '0.25rem' : 0;
}, function (props) {
  return props.theme.fontFamily;
});
Segment.defaultProps = { theme: DefaultTheme };

var _templateObject$9 = taggedTemplateLiteral(['\n  border: 1px solid #e8e8e8;\n  border-radius: ', ';\n  color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  font-family: ', ';\n  flex-direction: column;\n  flex-wrap: wrap;\n  font-size: 1em;\n  font-style: normal;\n  line-height: 1em;\n  margin: 0em 0.125em;\n  max-width: 100%;\n  position: relative;\n  vertical-align: baseline;\n  width: calc(960px / 3);\n'], ['\n  border: 1px solid #e8e8e8;\n  border-radius: ', ';\n  color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  font-family: ', ';\n  flex-direction: column;\n  flex-wrap: wrap;\n  font-size: 1em;\n  font-style: normal;\n  line-height: 1em;\n  margin: 0em 0.125em;\n  max-width: 100%;\n  position: relative;\n  vertical-align: baseline;\n  width: calc(960px / 3);\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n  font-family: ', ';\n  padding: 0.5833em 0.833em;\n'], ['\n  font-family: ', ';\n  padding: 0.5833em 0.833em;\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n  color: rgba(0, 0, 0, 0.85);\n  display: block;\n  font-family: ', ';\n  font-weight: bold;\n  line-height: 1em;\n  font-size: 1.3em;\n  width: inherit;\n'], ['\n  color: rgba(0, 0, 0, 0.85);\n  display: block;\n  font-family: ', ';\n  font-weight: bold;\n  line-height: 1em;\n  font-size: 1.3em;\n  width: inherit;\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  font-family: ', ';\n  color: rgba(0, 0, 0, 0.4);\n  margin-top: 0.5em;\n'], ['\n  font-family: ', ';\n  color: rgba(0, 0, 0, 0.4);\n  margin-top: 0.5em;\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  display: block;\n  font-family: ', ';\n  margin-top: 0.5em;\n  width: inherit;\n'], ['\n  display: block;\n  font-family: ', ';\n  margin-top: 0.5em;\n  width: inherit;\n']);

/**
 * The wrapping Card component.
 */
var Card = styled.div(_templateObject$9, function (_ref) {
  var rounded = _ref.rounded;
  return rounded ? '0.25rem' : 0;
}, function (props) {
  return props.theme.fontFamily;
});

/**
 * Content Wrapper.
 */
var Content = styled.div(_templateObject2$3, function (props) {
  return props.theme.fontFamily;
});

/**
 * Title of the Card.
 */
var Header$2 = styled.div(_templateObject3$1, function (props) {
  return props.theme.fontFamily;
});

/**
 * Card meta block.
 */
var Meta = styled.div(_templateObject4, function (props) {
  return props.theme.fontFamily;
});

/**
 * Cointains the major content of a Card.
 */
var Description = styled.div(_templateObject5, function (props) {
  return props.theme.fontFamily;
});

// Props
Card.propTypes = {
  rounded: propTypes.PropTypes.bool
};

Card.defaultProps = { theme: DefaultTheme

  // Assign children
};Card.Content = Content;
Card.Header = Header$2;
Card.Meta = Meta;
Card.Description = Description;

var _templateObject$a = taggedTemplateLiteral(['\n  background: transparent;\n  border-radius: 0rem;\n  border: none;\n  box-shadow: none;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  font-family: ', ';\n  margin: 1em 0em;\n  min-height: 0px;\n  padding: 0em;\n  transition: box-shadow 0.1s ease;\n  width: 100%;\n  -webkit-transition: box-shadow 0.1s ease;\n'], ['\n  background: transparent;\n  border-radius: 0rem;\n  border: none;\n  box-shadow: none;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  font-family: ', ';\n  margin: 1em 0em;\n  min-height: 0px;\n  padding: 0em;\n  transition: box-shadow 0.1s ease;\n  width: 100%;\n  -webkit-transition: box-shadow 0.1s ease;\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n  background: none;\n  border-radius: 0em;\n  border: none;\n  box-shadow: none;\n  display: block;\n  font-family: ', ';\n  flex: 1 1 auto;\n  font-size: 1em;\n  margin: 0em;\n  padding: 0em;\n  -ms-flex: 1 1 auto;\n  -webkit-box-flex: 1;\n'], ['\n  background: none;\n  border-radius: 0em;\n  border: none;\n  box-shadow: none;\n  display: block;\n  font-family: ', ';\n  flex: 1 1 auto;\n  font-size: 1em;\n  margin: 0em;\n  padding: 0em;\n  -ms-flex: 1 1 auto;\n  -webkit-box-flex: 1;\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n  color: rgba(0, 0, 0, 0.85);\n  display: inline-block;\n  font-family: ', ';\n  font-weight: bold;\n  margin: -0.21425em 0em 0em;\n'], ['\n  color: rgba(0, 0, 0, 0.85);\n  display: inline-block;\n  font-family: ', ';\n  font-weight: bold;\n  margin: -0.21425em 0em 0em;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n  color: rgba(0, 0, 0, 0.87);\n  font-family: ', ';\n  font-size: 1em;\n  line-height: 1.4285em;\n  margin-top: 0.6em;\n'], ['\n  color: rgba(0, 0, 0, 0.87);\n  font-family: ', ';\n  font-size: 1em;\n  line-height: 1.4285em;\n  margin-top: 0.6em;\n']);

/**
 * Item component.
 */
var Item$1 = styled.div(_templateObject$a, function (props) {
  return props.theme.fontFamily;
});

var Content$1 = styled.div(_templateObject2$4, function (props) {
  return props.theme.fontFamily;
});

var Header$3 = styled.div(_templateObject3$2, function (props) {
  return props.theme.fontFamily;
});

var Text$1 = styled.div(_templateObject4$1, function (props) {
  return props.theme.fontFamily;
});

// Default Theme

Item$1.defaultProps = { theme: DefaultTheme };
Content$1.defaultProps = { theme: DefaultTheme };
Header$3.defaultProps = { theme: DefaultTheme };
Text$1.defaultProps = { theme: DefaultTheme

  // Assign children
};Item$1.Content = Content$1;
Item$1.Header = Header$3;
Item$1.Text = Text$1;

var _templateObject$b = taggedTemplateLiteral(['\n  background-color: white;\n  border: 2px solid ', ';\n  border-radius: ', ';\n  display: inline-block;\n  color: ', ';\n  cursor: pointer;\n  font-family: ', ';\n  font-size: 1.1em;\n  font-style: normal;\n  line-height: 1em;\n  margin: 0 0.25em 0 0;\n  min-height: 1em;\n  padding: 0.6875em 1.5em 0.6875em;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: baseline;\n  &:hover {\n    background-color: ', ';\n  }\n'], ['\n  background-color: white;\n  border: 2px solid ', ';\n  border-radius: ', ';\n  display: inline-block;\n  color: ', ';\n  cursor: pointer;\n  font-family: ', ';\n  font-size: 1.1em;\n  font-style: normal;\n  line-height: 1em;\n  margin: 0 0.25em 0 0;\n  min-height: 1em;\n  padding: 0.6875em 1.5em 0.6875em;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: baseline;\n  &:hover {\n    background-color: ', ';\n  }\n']);

/**
 * Button component
 * HTML: `button`
 * @type {StyledComponentClass<JSX.IntrinsicElements["button"], any, JSX.IntrinsicElements["button"]>}
 */
var Button = styled.button(_templateObject$b, function (_ref) {
  var theme = _ref.theme;
  return theme.primaryColor;
}, function (_ref2) {
  var rounded = _ref2.rounded;
  return rounded ? '.15rem' : 0;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.primaryColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.secondaryColor;
});

// Props
Button.propTypes = {
  rounded: propTypes.PropTypes.bool

  // Default Theme
};Button.defaultProps = { theme: DefaultTheme };

var _templateObject$c = taggedTemplateLiteral(['\n  font-size: ', ';\n  font-family: ', ';\n'], ['\n  font-size: ', ';\n  font-family: ', ';\n']);

/**
 * Renders a `code` block
 */
var Code = styled.code(_templateObject$c, function (props) {
  return props.fontSize ? props.fontSize : props.theme.fontSize;
}, function (props) {
  return props.theme.codeFont;
});

Code.defaultProps = { theme: DefaultTheme };

var _templateObject$d = taggedTemplateLiteral(['\n  color: ', ';\n  display: block;\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n'], ['\n  color: ', ';\n  display: block;\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n']);

// Quick and dirty fix to get font sizes for headings
//TODO generate sizes dynamically from base size
var setFontSize = function setFontSize(value) {
  switch (value) {
    case 'h2':
      return '1.4rem';
    case 'h3':
      return '1.2rem';
    case 'h4':
      return '1rem';
    case 'h5':
      return '0.9rem';
    case 'h6':
      return '0.8rem';
    default:
      return '1.6rem';
  }
};

// TODO Find a solution to provide a `level` via the polymorphism prop `as`
// of v4
var Heading = styled.h1(_templateObject$d, function (props) {
  return props.color ? props.color : props.theme.fontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return setFontSize(props.as);
}, function (props) {
  return props.theme.headingFontWeight;
});

Heading.defaultProps = { theme: DefaultTheme };

var _templateObject$e = taggedTemplateLiteral(['\n  display: block;\n  flex: 0 0 auto;\n  height: auto;\n  padding: 0;\n  position: relative;\n  max-width: 100%;\n  -webkit-box-flex: 0;\n'], ['\n  display: block;\n  flex: 0 0 auto;\n  height: auto;\n  padding: 0;\n  position: relative;\n  max-width: 100%;\n  -webkit-box-flex: 0;\n']);

/**
 * Image component.
 * HTML: `img`
 */
var Image = styled.img(_templateObject$e);

var _templateObject$f = taggedTemplateLiteral(['\n  font-family: ', ';\n  font-size: 1rem;\n  line-height: 2rem;\n'], ['\n  font-family: ', ';\n  font-size: 1rem;\n  line-height: 2rem;\n']);

/**
 * Input field, defaults to `text`.
 * HTML: `input`
 * @type {StyledComponentClass<*, any, *>}
 */
var Input = styled.input.attrs({
  type: 'text'
})(_templateObject$f, function (props) {
  return props.theme.fontFamily;
});

Input.defaultProps = { theme: DefaultTheme };

var _templateObject$g = taggedTemplateLiteral(['\n  border: none;\n  color: ', ';\n  display: inline-block;\n  font-family: ', ';\n  font-size: 1em;\n  font-style: normal;\n  font-weight: bold;\n  line-height: 1em;\n  margin: 0 0.125em;\n  min-height: 1em;\n  vertical-align: baseline;\n'], ['\n  border: none;\n  color: ', ';\n  display: inline-block;\n  font-family: ', ';\n  font-size: 1em;\n  font-style: normal;\n  font-weight: bold;\n  line-height: 1em;\n  margin: 0 0.125em;\n  min-height: 1em;\n  vertical-align: baseline;\n']);

/**
 * A Basic Label representing a HTML form label.
 */
var Label = styled.label(_templateObject$g, function (_ref) {
  var theme = _ref.theme;
  return theme.primaryColor;
}, function (props) {
  return props.theme.fontFamily;
});

// Default Theme
Label.defaultProps = { theme: DefaultTheme };

var _templateObject$h = taggedTemplateLiteral(['\n  font-family: ', ';\n  font-size: 1rem;\n'], ['\n  font-family: ', ';\n  font-size: 1rem;\n']);

/**
 * Link element
 * HTML: `a`
 * @type {StyledComponentClass<*, any, *>}
 */
var Link = styled.a.attrs({
  href: function href(props) {
    return props.to || null;
  },
  rel: function rel(props) {
    return props.external ? 'noopener noreferrer' : null;
  }
})(_templateObject$h, function (props) {
  return props.theme.fontFamily;
});

Link.defaultProps = { theme: DefaultTheme };

var _templateObject$i = taggedTemplateLiteral(['\n  color: ', ';\n  font-family: ', ';\n  font-size: 1rem;\n  line-height: 1.5rem;\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-size: 1rem;\n  line-height: 1.5rem;\n']);

/**
 * Text element
 * HTML: `p`
 * @type {StyledComponentClass<JSX.IntrinsicElements["p"], any, JSX.IntrinsicElements["p"]>}
 */
var Text$2 = styled.p(_templateObject$i, function (props) {
  return props.color || props.theme.fontColor;
}, function (props) {
  return props.theme.fontFamily;
});
Text$2.defaultProps = { theme: DefaultTheme };

var _templateObject$j = taggedTemplateLiteral(['\n  font-size: 1rem;\n  font-family: ', ';\n  text-align: ', ';\n'], ['\n  font-size: 1rem;\n  font-family: ', ';\n  text-align: ', ';\n']);

/**
 * View element
 * HTML: `div`
 * @type {StyledComponentClass<JSX.IntrinsicElements["p"], any, JSX.IntrinsicElements["p"]>}
 */
var View = styled.p(_templateObject$j, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.centered ? 'center' : 'left';
});

View.defaultProps = { theme: DefaultTheme };

/* Themes */

exports.DefaultTheme = DefaultTheme;
exports.StyledComponentsTheme = Theme;
exports.Grid = Grid;
exports.Menu = Menu;
exports.Message = Message;
exports.Badge = Badge;
exports.Container = Container;
exports.Header = Header$1;
exports.Loader = Loader;
exports.NavBar = NavBar;
exports.Segment = Segment;
exports.Card = Card;
exports.Item = Item$1;
exports.Button = Button;
exports.Code = Code;
exports.Heading = Heading;
exports.Image = Image;
exports.Input = Input;
exports.Label = Label;
exports.Link = Link;
exports.Text = Text$2;
exports.View = View;
